import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { getURLProfileDetails, updateUserProfile } from '../../../redux/actions/userActions';
import urls from '../../../routing/urls';

import About from './About/About';
import Education from './Education/Education';
import Experience from './Experience/Experience';
import LinkedinPopup from './LinkedinPopup/LinkedinPopup';
import Membership from './Membership/Membership';
import ProfileHeader from './ProfileHeader/ProfileHeader';

import styles from './Profile.module.scss';

const Profile = ({ isPublic, variant }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { url } = useParams();
  const { currentUser } = useSelector((state) => state.authReducer);

  const id = currentUser?.user?.id;
  const userDetails = useSelector((state) =>
    variant === 'url-profile' ? state.userReducer.urlProfile : state.userReducer.user
  );
  const [showLinkedinPopup, setShowLinkedinPopup] = useState(false);

  useEffect(() => {
    if (userDetails && userDetails.is_linkedin_imported === showLinkedinPopup) {
      setShowLinkedinPopup(true);
    }
  }, [userDetails]);

  const handleProfileUpdate = useCallback(
    (data, successCallback, errorCallback) => {
      dispatch(updateUserProfile(id, data, successCallback, errorCallback));
    },
    [id]
  );

  useEffect(() => {
    if (!isPublic) {
      const { personal_url } = userDetails;
      const { pathname } = window.location;
      const splittedPathname = pathname.split('/');
      if (splittedPathname.length === 4) {
        const urlParam = splittedPathname[3];
        if (urlParam !== personal_url) {
          navigate(`${urls.profile}`);
        }
      } else if (personal_url) {
        navigate(`${urls.profile}/${personal_url}`);
      }
    }
  }, [userDetails]);

  useEffect(() => {
    if (variant === 'url-profile') {
      dispatch(getURLProfileDetails(url, () => navigate(urls.payments)));
    }
  }, [variant, url]);

  return (
    <div className={styles.container}>
      {!!userDetails.id && (
        <div className={styles.content}>
          <div className={styles.headerPopupCont}>
            <ProfileHeader currentUser={userDetails} handleProfileUpdate={handleProfileUpdate} isPublic={isPublic} />
            {showLinkedinPopup && <LinkedinPopup onClose={() => setShowLinkedinPopup(false)} />}
          </div>
          <About bio={userDetails?.bio} handleProfileUpdate={handleProfileUpdate} isPublic={isPublic} />
          <Experience
            handleProfileUpdate={handleProfileUpdate}
            experienceData={userDetails.user_experiences}
            allowEdit={!isPublic}
          />
          <Education
            educationData={userDetails.user_educations}
            handleProfileUpdate={handleProfileUpdate}
            allowEdit={!isPublic}
          />
          <Membership
            memberships={userDetails?.memberships}
            handleProfileUpdate={handleProfileUpdate}
            isPublic={isPublic}
          />
        </div>
      )}
    </div>
  );
};

export default Profile;
